import { render, staticRenderFns } from "./ItemWithLink.vue?vue&type=template&id=dd1d46f2&"
import script from "./ItemWithLink.vue?vue&type=script&lang=ts&"
export * from "./ItemWithLink.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports